import API from './API.ts'

export default {
  //
  // GET
  //
  getSeasons () {
    return API.httpClient.get('seasons')
  },
  getSeasonBookings ({ year, seasonType }) {
    return API.httpClient.get('seasons/bookings', {
      params: {
        year,
        season_type: seasonType
      }
    })
  },
  getCopiedBookingsInformation ({ year, seasonType }) {
    return API.httpClient.get('seasons/copied-bookings-information', {
      params: {
        year,
        season_type: seasonType
      }
    })
  },
  getPreviousSeasonBookingsData (seasonId) {
    return API.httpClient.get('seasons/previous-season-bookings-data', {
      params: {
        season_id: seasonId
      }
    })
  },
  getCalendarDates () {
    return API.httpClient.get('seasons/calendar-dates')
  },

  //
  // POST
  //
  confirmSeasonBookingDraft (bookingId) {
    return API.httpClient.post('seasons/update-booking-status', {
      booking_id: bookingId,
      status: 'confirmed'
    })
  },
  deleteSeasonBookingDraft (bookingId) {
    return API.httpClient.post('seasons/update-booking-status', {
      booking_id: bookingId,
      status: 'cancelled'
    })
  },
  ignoreCopyBookingToNextSeason: function (bookingId) {
    return API.httpClient.post('seasons/ignore-copy-booking-to-next-season', {
      booking_id: bookingId
    })
  },
  copyBookingToNextSeason: function (bookingId) {
    return API.httpClient.post('seasons/copy-booking-to-next-season', {
      booking_id: bookingId
    })
  },
  saveSeason: function ({ season, updateBookingsCheckInDateStrategy, updateBookingsCheckOutDateStrategy, updateBookingsPriceStrategy }) {
    return API.httpClient.post('seasons/save', {
      season,
      update_bookings_check_in_date_strategy: updateBookingsCheckInDateStrategy,
      update_bookings_check_out_date_strategy: updateBookingsCheckOutDateStrategy,
      update_bookings_price_strategy: updateBookingsPriceStrategy
    })
  },
  deleteSeason: function ({ seasonId }) {
    return API.httpClient.post('seasons/delete', {
      season_id: seasonId
    })
  }
}
